import fallbackImg from "../../assets/user.png"; // Import the fallback image

export const userColumns = [
  {
    field: "tokenNo",
    headerName: "Token No",
    width: 150,
  },
  {
    field: "patientName",
    headerName: "Patient Name",
    width: 200,
  },
  {
    field: "clinicName",
    headerName: "Clinic Name",
    width: 200,
  },
  {
    field: "phone",
    headerName: "Phone",
    width: 120,
  },
  {
    field: "title",
    headerName: "Doctor Name",
    width: 200,
  },
  {
    field: "status",
    headerName: "Status",
    width: 120,
  },

];
